export const discActionTypes = {
    DISCS_REQUESTED: 'DISCS_REQUESTED',
    DISCS_RECEIVED: 'DISCS_RECEIVED',
    DISCS_RECEIVED_FOR_SELECT: 'DISCS_RECEIVED_FOR_SELECT',
    DISCS_REQUEST_FAILED: 'DISCS_REQUEST_FAILED',
    CLEAR_DISC_PACKAGES: 'CLEAR_DISC_PACKAGES',

    CREATE_DISC_REQUEST: 'CREATE_DISC_REQUEST',
    CREATE_DISC_SUCCESS: 'CREATE_DISC_SUCCESS',
    CREATE_DISC_FAILED: 'CREATE_DISC_FAILED',

    ADD_VIDEOS_TO_DISC_REQUEST: 'ADD_VIDEOS_TO_DISC_REQUEST',
    ADD_VIDEOS_TO_DISC_SUCCESS: 'ADD_VIDEOS_TO_DISC_SUCCESS',
    ADD_VIDEOS_TO_DISC_FAILURE: 'ADD_VIDEOS_TO_DISC_FAILURE',

    ADD_PHOTOS_TO_DISC_REQUEST: 'ADD_PHOTOS_TO_DISC_REQUEST',
    ADD_PHOTOS_TO_DISC_SUCCESS: 'ADD_PHOTOS_TO_DISC_SUCCESS',
    ADD_PHOTOS_TO_DISC_FAILURE: 'ADD_PHOTOS_TO_DISC_FAILURE',

    ADD_COLLECTION_TO_DISC_REQUEST: 'ADD_COLLECTION_TO_DISC_REQUEST',
    ADD_COLLECTION_TO_DISC_SUCCESS: 'ADD_COLLECTION_TO_DISC_SUCCESS',
    ADD_COLLECTION_TO_DISC_FAILURE: 'ADD_COLLECTION_TO_DISC_FAILURE',

    DELETE_DISC_SUCCESS: "DELETE_DISC_SUCCESS",
    DELETE_DISC_FAILED: "DELETE_DISC_FAILED",

    DELETE_DISC_DISCRIPTOR_SUCCESS: "DELETE_DISC_DISCRIPTOR_SUCCESS",
    DELETE_DISC_DISCRIPTOR_FAILED: "DELETE_DISC_DISCRIPTOR_FAILED",

    FINALIZE_DISC_REQUEST: "FINALIZE_DISC",
    FINALIZE_DISC_SUCCESS: "FINALIZE_DISC_SUCCESS",
    FINALIZE_DISC_FAILED: "FINALIZE_DISC_FAILED",

    ADD_ALBUM_TO_DISC: "ADD_ALBUM_TO_DISC",
    ADD_ELEMENT_TO_DISC: "ADD_ELEMENT_TO_DISC",
    ADD_TO_DISC_SUCCESS: "ADD_TO_DISC_SUCCESS",
    ADD_TO_DISC_FAILED: "ADD_TO_DISC_FAILED",
    ADD_TO_DISC_REQUEST: "ADD_TO_DISC_REQUEST",
    ADD_DISC_TO_DISC_SUCCESS: "ADD_DISC_TO_DISC_SUCCESS",

    FETCH_DISC_REQUEST:"FETCH_DISC_REQUEST",
    FETCH_DISC_SUCCESS:"FETCH_DISC_SUCCESS",
    FETCH_DISC_FAILED:"FETCH_DISC_FAILED",
    CLEAR_DISC_ITEMS: "CLEAR_DISC_ITEMS",

    CLEAR_SELECTED_DISC_ITEMS:"CLEAR_SELECTED_DISC_ITEMS",
    SELECT_DISC_ITEM:"SELECT_DISC_ITEM",
    DESELECT_DISC_ITEM:"DESELECT_DISC_ITEM",
    ENABLE_DISC_ITEM_SELECTION_MODE:"ENABLE_DISC_ITEM_SELECTION_MODE",
    DISABLE_DISC_ITEM_SELECTION_MODE:"DISABLE_DISC_ITEM_SELECTION_MODE",

    DELETE_SELECTED_ITEMS_REQUESTED:"DELETE_SELECTED_ITEMS_REQUESTED",
    DELETE_SELECTED_ITEMS_SUCCESS:"DELETE_SELECTED_ITEMS_SUCCESS",
    DELETE_SELECTED_ITEMS_FAILED:"DELETE_SELECTED_ITEMS_FAILED",

    UPDATE_CHAPTER_FAILED:"UPDATE_CHAPTER_FAILED",
    UPDATE_CHAPTER_SUCCESS:"UPDATE_CHAPTER_SUCCESS",
    UPDATE_CHAPTER_REQUESTED:"UPDATE_CHAPTER_REQUESTED",

    ENABLE_DISC_ITEM_ARRANGE_MODE:"ENABLE_DISC_ITEM_ARRANGE_MODE",
    DISABLE_DISC_ITEM_ARRANGE_MODE:"DISABLE_DISC_ITEM_ARRANGE_MODE",
    SET_DISC_ITEM_SORT:"SET_DISC_ITEM_SORT",
    SAVE_DISC_ARRANGEMENT:"SAVE_DISC_ARRANGEMENT",
    MOVE_DISC_ITEM_AFTER:"MOVE_DISC_ITEM_AFTER",
    SAVE_DISC_ARRANGEMENT_SUCCESS:"SAVE_DISC_ARRANGEMENT_SUCCESS",
    SAVE_DISC_ARRANGEMENT_FAILED:"SAVE_DISC_ARRANGEMENT_FAILED",
    DISC_WIZARD_SET:"DISC_WIZARD_SET",
    DISC_WIZARD_SELECT_MEDIA:"DISC_WIZARD_SELECT_MEDIA",
    DISC_WIZARD_SAVE_FAILED:"DISC_WIZARD_SAVE_FAILED",
    DISC_WIZARD_SAVE_SUCCESS:"DISC_WIZARD_SAVE_SUCCESS",
    DISC_WIZARD_SAVE_START:"DISC_WIZARD_SAVE_START",
    DISC_WIZARD_DATA_RECEIVED:"DISC_WIZARD_DATA_RECEIVED",
    DISC_WIZARD_DATA_REQUESTED:"DISC_WIZARD_DATA_REQUESTED",
    DISC_WIZARD_SET_ROLLBACK_POINT:"DISC_WIZARD_SET_ROLLBACK_POINT",
    DISC_WIZARD_ROLLBACK:"DISC_WIZARD_ROLLBACK",
    DISC_WIZARD_ROLLBACK_SAVED:"DISC_WIZARD_ROLLBACK_SAVED",

    DISC_ITEM_ROTATE_REQUEST:'DISC_ITEM_ROTATE_REQUEST',
    DISC_ITEM_ROTATE_SUCCESS:'DISC_ITEM_ROTATE_SUCCESS',
    DISC_ITEM_ROTATE_ERROR:'DISC_ITEM_ROTATE_ERROR',
    DISC_SCROLL:'DISC_SCROLL',
    DISC_ITEM_SCROLL:'DISC_ITEM_SCROLL'



};


// WEBPACK FOOTER //
// ./src/disc/actions/disc-action-types.js